import axios from "@/plugins/axios.js";
import store from "@/store";
// state
export const state = {
  orders: [],
  scheduledOrders: [],
};

// mutations
export const mutations = {
  SET_ORDERS: (state, data) => {
    state.orders = data;
  },
  SET_SCHEDULED_ORDERS: (state, data) => {
    state.scheduledOrders = data;
  },
};

// actions
export const actions = {
  async setLoadOrders({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get(
      "/admin/store/" + store.getters.storeIdAdmin + "/orders"
    );
    commit("SET_ORDERS", data.data);
    store.dispatch("loading/done");
  },
  async setLoadScheduledOrders({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get(
      "/admin/store/" + store.getters.storeIdAdmin + "/schedules"
    );
    commit("SET_SCHEDULED_ORDERS", data.data);
    store.dispatch("loading/done");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
